import { TenantGroupBadge } from '../../../components/TenantGroupBadge/TenantGroupBadge'
import { formatDate } from '../../../helpers/formatDate'
import type { TenantDTO, EditRowDef } from '../../../types'

export function buildTenantEditRows(tenant: TenantDTO): EditRowDef[] {
  return [
    { mode: 'readonly', label: 'ID', value: <span className="font-monospace small">{tenant.id}</span> },
    { mode: 'readonly', label: 'Code', value: <span className="fw-medium">{tenant.code}</span> },
    { mode: 'editable', field: { name: 'name', label: 'Name', type: 'text', required: true }, initialValue: tenant.name },
    { mode: 'readonly', label: 'Tenant Group', value: <TenantGroupBadge tenantGroupId={tenant.tenantGroupId} /> },
    { mode: 'readonly', label: 'Created', value: formatDate(tenant.createdAt) },
    { mode: 'readonly', label: 'Updated', value: formatDate(tenant.updatedAt) },
  ]
}
